export default "__VITE_ASSET__DZfZdIAs__"